import React from "react";
import SEOLandingPage from "../../../components/tools/SEOLandingPage";

const AnkiAlternative: React.FC = () => {
  return (
    <SEOLandingPage
      // SEO
      title="Best Anki Alternative 2025 - Easier Spaced Repetition | YouWo AI"
      metaDescription="Looking for an Anki alternative that's easier to use? YouWo AI offers AI flashcard creation with built-in spaced repetition. No complex setup required."
      keywords="anki alternative, anki competitor, spaced repetition app, flashcard app, srs flashcards, medical student flashcards, language learning flashcards"
      canonicalUrl="https://youwo.ai/tools/anki-alternative"
      // Hero
      headline="Anki Alternative with AI-Powered Flashcard Creation"
      subheadline="Get the power of spaced repetition without the complex setup. YouWo AI creates flashcards automatically and schedules reviews for optimal memory retention."
      heroIcon="lucide:repeat"
      heroIconColor="text-blue-500"
      heroIconBg="bg-blue-50"
      // Problem/Solution
      problemTitle="Why Students Struggle with Anki"
      problemDescription="Anki is powerful but has a steep learning curve. Creating cards takes forever, the interface is outdated, and you need add-ons for basic features. Many students give up before seeing results."
      solutionTitle="Spaced Repetition Made Simple"
      solutionDescription="YouWo AI gives you the scientifically-proven benefits of spaced repetition with zero setup hassle. AI creates your cards, and our smart algorithm schedules reviews automatically."
      // Comparison
      competitorName="Anki"
      comparisonPoints={[
        { feature: "AI Card Generation", youwoai: true, competitor: false },
        { feature: "Spaced Repetition", youwoai: true, competitor: true },
        { feature: "Easy to Use", youwoai: true, competitor: false },
        { feature: "Modern Interface", youwoai: true, competitor: false },
        { feature: "PDF Import", youwoai: true, competitor: "Add-on" },
        { feature: "Image Occlusion", youwoai: true, competitor: "Add-on" },
        { feature: "Mobile App", youwoai: true, competitor: "$25" },
        { feature: "Cloud Sync", youwoai: true, competitor: "Limited" },
      ]}
      // Features
      features={[
        {
          icon: "lucide:brain",
          title: "Active Recall Learning",
          description: "Flashcards use active recall - the most effective learning technique proven by science.",
        },
        {
          icon: "lucide:globe",
          title: "100+ Languages",
          description: "Create and study flashcards in over 100 languages.",
        },
        {
          icon: "lucide:sparkles",
          title: "Zero Setup Required",
          description: "Start studying immediately. No complex configurations or add-ons needed.",
        },
        {
          icon: "lucide:layout-template",
          title: "Beautiful Card Templates",
          description: "Modern, visually appealing cards that make studying more enjoyable.",
        },
        {
          icon: "lucide:smartphone",
          title: "Free Mobile App",
          description: "Study on any device with our free iOS and Android apps.",
        },
        {
          icon: "lucide:share-2",
          title: "Export with Pro",
          description: "Export to Anki format and share decks with Pro.",
        },
      ]}
      // CTA
      ctaText="Switch to YouWo AI Free"
      ctaLink="https://apps.apple.com/app/youwo-ai-agent/id6760689478"
      // Related
      relatedTools={[
        { name: "AI Flashcard Maker", href: "/tools/flashcard-maker", icon: "lucide:layers" },
        { name: "Quizlet Alternative", href: "/tools/quizlet-alternative", icon: "lucide:book-open" },
        { name: "Lecture Notes AI", href: "/tools/lecture-notes", icon: "lucide:graduation-cap" },
        { name: "PDF Summarizer", href: "/tools/pdf-summarizer", icon: "lucide:file-text" },
      ]}
    />
  );
};

export default AnkiAlternative;
